// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2BukjDrXAjDYp5wjl3CQeN {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  /* margin-top: 25px; */\n}\n\n._3BqC835zYOzAeL3CSWL8nP {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.5;\n  text-align: left;\n  padding: 25px 0;\n}\n\n.ofdwCnDQAPt9kX1774d8d {\n  font-size: 20px;\n  line-height: 1.5;\n  padding-bottom: 25px;\n}\n\n._3Qdux7rVKjOKzeZAamNsWI {\n  align-self: flex-end;\n}\n\n._3Qdux7rVKjOKzeZAamNsWI button {\n  margin-left: 15px;\n}\n\n.HC-9iJywW0xLppgVtjM6t {\n  align-self: center;\n}\n\n._2wKWEpDcItTv17Cafm1DWI {\n  cursor: pointer;\n  color: #2fb5c7;\n}\n._2wKWEpDcItTv17Cafm1DWI:hover {\n  color: #207d89;\n  text-decoration: underline;\n}", ""]);
// Exports
exports.locals = {
	"modalContainer": "_2BukjDrXAjDYp5wjl3CQeN",
	"modalText": "_3BqC835zYOzAeL3CSWL8nP",
	"modalTextSecondary": "ofdwCnDQAPt9kX1774d8d",
	"modalButtons": "_3Qdux7rVKjOKzeZAamNsWI",
	"modalButtonsCentered": "HC-9iJywW0xLppgVtjM6t",
	"textLink": "_2wKWEpDcItTv17Cafm1DWI"
};
module.exports = exports;
